"use strict";

exports.__esModule = true;
exports.useOnFocusReportValidity = useOnFocusReportValidity;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function useOnFocusReportValidity(ref) {
  _react["default"].useEffect(function () {
    if (ref.current) {
      var inputElement = ref.current;

      var onFocus = function onFocus() {
        inputElement.reportValidity();
      };

      inputElement.addEventListener('focus', onFocus);
      return function () {
        inputElement.removeEventListener('focus', onFocus);
      };
    }
  }, [ref]);
}